import { FormSkeleton } from "./form-skeleton";

export default FormSkeleton;
